// Kiosk Ekle / Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.addKiosk';

export const addKioskGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kiosk nasıl eklenir veya düzenlenir?'),
  intro: t(`${G}.intro`, 'Bu pencerede kioskun temel bilgilerini girersiniz. Reklam, ürün, ödeme gibi ayarlar kayıttan sonra listedeki ⋮ → "Ayarlar" ile yapılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Kiosk bilgileri'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Yeni kiosk mu, düzenleme mi?'),
      text: t(`${G}.s1.text`, '"Yeni Kiosk Ekle" düğmesinden açıldıysa başlık "Yeni Kiosk Ekle", listedeki ⋮ → "Düzenle" ile açıldıysa "Kiosk Düzenle" olur ve alanlar mevcut bilgilerle dolu gelir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kiosk adı ve durum'),
      text: t(`${G}.s2.text`, 'Kiosk Adı zorunludur, en fazla 100 karakter. Durum: Aktif, Pasif veya Bakımda (yeni kioskta Aktif gelir).'),
      tips: [
        t(`${G}.s2.tip1`, 'Açıklama isteğe bağlıdır, en fazla 500 karakter.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Şube, ekran boyutu ve cihaz ID'),
      text: t(`${G}.s3.text`, 'Kioskun bulunduğu şubeyi seçin; boş bırakırsanız "Şube Seçilmedi" olarak kaydedilir ve listede "Atanmamış" görünür. Ekran Boyutu 21, 24 veya 27 inç olabilir. Cihaz ID isteğe bağlıdır (en fazla 100 karakter, örn. KIOSK-001).'),
      tips: [
        t(`${G}.s3.tip1`, 'Şube, kioskun ödeme ve mutfak ekranı ayarlarında hangi şubenin hesap, depo ve QR menülerinin listeleneceğini belirler.'),
        t(`${G}.s3.tip2`, 'Ekran boyutu, reklam görsellerinin önerilen çözünürlüğünü belirlerken işinize yarar.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kaydedin'),
      text: t(`${G}.s4.text`, '"Kiosk Ekle" (düzenlemede "Kiosk Güncelle") düğmesi Kiosk Adı dolunca açılır. Kayıttan sonra pencere kapanır ve liste yenilenir. Hata olursa pencerenin üstünde kırmızı mesaj çıkar.'),
    },
  ],
});
